export const highlightSelectedText = (
  textToHightlight: string,
  text: string,
): string => {
  const trimmedTextToHighlight = textToHightlight.trim();

  if (!trimmedTextToHighlight) {
    return escapeHtml(text);
  }

  const literalMatch = highlightWithRegex(
    text,
    new RegExp(escapeRegExp(trimmedTextToHighlight), "gi"),
  );

  if (literalMatch.hasMatch) {
    return literalMatch.text;
  }

  const normalizedRegex = getNormalizedHighlightRegex(trimmedTextToHighlight);

  if (!normalizedRegex) {
    return escapeHtml(text);
  }

  return highlightWithRegex(text, normalizedRegex).text;
};

const highlightWithRegex = (text: string, regex: RegExp) => {
  let result = "";
  let lastIndex = 0;
  let hasMatch = false;
  let match = regex.exec(text);

  while (match) {
    if (match[0] === "") {
      break;
    }

    hasMatch = true;
    result += escapeHtml(text.slice(lastIndex, match.index));
    result += `<span style="color:#3C78FF">${escapeHtml(match[0])}</span>`;
    lastIndex = match.index + match[0].length;
    match = regex.exec(text);
  }

  result += escapeHtml(text.slice(lastIndex));

  return { hasMatch, text: result };
};

const getNormalizedHighlightRegex = (textToHightlight: string) => {
  const tokens = textToHightlight.match(/[a-z0-9]+/gi);

  if (!tokens?.length) {
    return null;
  }

  const startsWithSeparator = /^[^a-z0-9]+/i.test(textToHightlight);
  const endsWithSeparator = /[^a-z0-9]+$/i.test(textToHightlight);
  const tokenPattern = tokens.map(escapeRegExp).join("[^a-z0-9]+");

  return new RegExp(
    `${startsWithSeparator ? "[^a-z0-9]+" : ""}${tokenPattern}${
      endsWithSeparator ? "[^a-z0-9]+" : ""
    }`,
    "gi",
  );
};

const escapeRegExp = (text: string) =>
  text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const escapeHtml = (text: string) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
